import {Input} from "@heroui/input";
import {Button} from "@heroui/button";
import {CompetitorSettings} from "../../types";
import {Controller, SubmitHandler, useForm} from "react-hook-form";
import {getCompetitorSettings, postCompetitorSettings} from "../../shared/queries";
import toast from "react-hot-toast";
import {useSelector} from "react-redux";
import {RootState} from "../../store";
import {parseInt} from "lodash";
import {useQuery} from "react-query";
import {Form} from "@heroui/react";

export default function CompetitiveSet() {

    const {
        currentHotel
    } = useSelector((state: RootState) => state.hotels)

    const {
        control,
        handleSubmit,
        setValue,
        formState: { isLoading, isSubmitting }
    } = useForm<CompetitorSettings>()


    useQuery(['competitiveSet', currentHotel], () => getCompetitorSettings(currentHotel || 0), {
        onSuccess: data => {
            setValue('accommodationUrl', data.accommodationUrl)
            setValue('competitor1Url', data.competitor1Url)
            setValue('competitor2Url', data.competitor2Url)
            setValue('competitor3Url', data.competitor3Url)
            setValue('competitor4Url', data.competitor4Url)
        }
    })

    const onSubmit: SubmitHandler<CompetitorSettings> = async (data) => {
        try {
            await postCompetitorSettings({
                ...data,
                idAccommodation: currentHotel ? parseInt(currentHotel.toString()) : 0
            })
            toast.success('Competitive set configurato con successo')
        } catch (e) {
            toast.error('Impossibile salvare la configurazione')
        }
    }


    return (
        <div>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <div className={'border rounded-md mt-6 overflow-hidden p-6 mb-6'}>
                    <div className="text-3xl font-bold text-slate-700">
                        Controlla i tuoi competitor
                    </div>
                    <div className="text-slate-600 text-lg mt-4">
                        aggiungi fino a 4 competitor che vuoi tracciare, ci occuperemo noi di monitorare il loro andamento su booking.com fornedoti informazioni utili
                        per migliorare la tua strategia commerciale e la tua conversione diretta
                    </div>

                    <div className="mt-12">
                        <div className="flex space-x-4">
                            <div>
                                <div className="h-10 w-10 flex items-center justify-center font-bold text-lg text-slate-500 rounded-full bg-slate-100">
                                    1
                                </div>
                            </div>

                            <div>
                                <div className="mt-1 mb-2 text-lg font-bold text-slate-600">
                                    Configura il tuo hotel
                                </div>

                                <Controller
                                    control={control}
                                    name="accommodationUrl"
                                    render={({field: {name, value, onChange, onBlur, ref}, fieldState: {invalid, error}}) => (
                                        <Input
                                            ref={ref}
                                            variant="bordered"
                                            className={'w-96'}
                                            errorMessage={error?.message}
                                            validationBehavior="aria"
                                            isInvalid={invalid}
                                            label="Url Booking.com del secondo competitor"
                                            name={name}
                                            value={value}
                                            onBlur={onBlur}
                                            onChange={onChange}
                                            isRequired
                                        />
                                    )}
                                    rules={{required: "L'url del primo competitor è obbligatorio"}}
                                />
                            </div>
                        </div>

                        <div className="flex space-x-4 mt-6">
                            <div>
                                <div className="h-10 w-10 flex items-center justify-center font-bold text-lg text-slate-500 rounded-full bg-slate-100">
                                    2
                                </div>
                            </div>

                            <div>
                                <div className="mt-1 mb-2 text-lg font-bold text-slate-600">
                                    Configura i tuoi competitor (fino a 4)
                                </div>

                                <div className="flex flex-col space-y-2">
                                    <Controller
                                        control={control}
                                        name="competitor1Url"
                                        render={({field: {name, value, onChange, onBlur, ref}, fieldState: {invalid, error}}) => (
                                            <Input
                                                ref={ref}
                                                variant="bordered"
                                                className={'w-96'}
                                                isRequired
                                                errorMessage={error?.message}
                                                validationBehavior="aria"
                                                isInvalid={invalid}
                                                label="Url Booking.com del primo competitor"
                                                name={name}
                                                value={value}
                                                onBlur={onBlur}
                                                onChange={onChange}
                                            />
                                        )}
                                        rules={{required: "L'url del primo competitor è obbligatorio"}}
                                    />

                                    <Controller
                                        control={control}
                                        name="competitor2Url"
                                        render={({field: {name, value, onChange, onBlur, ref}, fieldState: {invalid, error}}) => (
                                            <Input
                                                ref={ref}
                                                variant="bordered"
                                                className={'w-96'}
                                                errorMessage={error?.message}
                                                validationBehavior="aria"
                                                isInvalid={invalid}
                                                label="Url Booking.com del secondo competitor"
                                                name={name}
                                                value={value}
                                                onBlur={onBlur}
                                                onChange={onChange}
                                            />
                                        )}
                                    />

                                    <Controller
                                        control={control}
                                        name="competitor3Url"
                                        render={({field: {name, value, onChange, onBlur, ref}, fieldState: {invalid, error}}) => (
                                            <Input
                                                ref={ref}
                                                variant="bordered"
                                                className={'w-96'}
                                                errorMessage={error?.message}
                                                validationBehavior="aria"
                                                isInvalid={invalid}
                                                label="Url Booking.com del terzo competitor"
                                                name={name}
                                                value={value}
                                                onBlur={onBlur}
                                                onChange={onChange}
                                            />
                                        )}
                                    />

                                    <Controller
                                        control={control}
                                        name="competitor4Url"
                                        render={({field: {name, value, onChange, onBlur, ref}, fieldState: {invalid, error}}) => (
                                            <Input
                                                ref={ref}
                                                variant="bordered"
                                                className={'w-96'}
                                                errorMessage={error?.message}
                                                validationBehavior="aria"
                                                isInvalid={invalid}
                                                label="Url Booking.com del quarto competitor"
                                                name={name}
                                                value={value}
                                                onBlur={onBlur}
                                                onChange={onChange}
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <Button type={'submit'} color="primary" isLoading={isLoading || isSubmitting}>Salva</Button>
            </Form>
        </div>
    )

}
